import 'angular';
import '../companionClient/companionNotSupportedModal/companionNotSupportedModal.html';
import * as _ from 'lodash-es';
import { Utils } from '@amzn/aws-workdocs-web-client-common';
import { CompanionClientService } from "../companionClient/companionClient";
import { isCompanionSupportedBrowser, 
    getCompanionDownloadUrl as getCompanionDownloadUrlCompanion, 
} from "@amzn/aws-workdocs-web-companion-common";
const customProtocolCheck = require('custom-protocol-check');
import Features from "../feature-manager/Features";

let InstallTrigger: any;

/**
 * @ngdoc service
 * @name CompanionService
 *
 * @description
 * CompanionService contains all logics relating to accessing companion.
 * CompanionClientService provide an companion client instance.
 */
angular.module('GorillaBoy')
.factory('CompanionService', [
    '$rootScope',
    '$q',
    '$log',
    '$uibModal',
    '$translate',
    '$timeout',
    'authenticatedUser',
    'RegionService',
    'EndpointConfig',
    'ClientMetricsService',
    'BrowserService',
    'localStorageService',
    'AuthService',
    'MessageManager',
    'SignalProvider',
    'SourceConstant',
    'AppConstants',
    'CompanionClientService',
    'FeatureManagerService',
    CompanionService
]);
function CompanionService($rootScope, $q, $log: ng.ILogService, $uibModal, $translate, $timeout, authenticatedUser, RegionService, EndpointConfig, ClientMetricsService, BrowserService, localStorageService, AuthService, MessageManager, SignalProvider, SourceConstant, AppConstants, CompanionClientService: CompanionClientService, FeatureManagerService) {
    var METRICS_EVENTS = {
        ERROR_DUE_TO_OFFLINE_STATUS: {name: 'WorkDocs_Companion_User_Offline'},
        EDIT_BUTTON_CLICKED: {name: 'WorkDocs_Companion_Edit_Clicked'},
        FILE_OPEN_LATENCY: {name: 'WorkDocs_Companion_file_open_latency'},
        FOLDER_DOWNLOAD_BUTTON_CLICKED: {name: 'WorkDocs_Companion_Folder_Download_Clicked'},
        FOLDER_DOWNLOAD_LATENCY: {name: 'WorkDocs_Companion_folder_download_latency'},
        PURGE_VERSIONS_LATENCY: {name: 'WorkDocs_Companion_purge_versions_latency'},

        FILE_AND_FOLDER_DOWNLOAD_BUTTON_CLICKED: {name: 'WorkDocs_Companion_File_And_Folder_Download_Clicked'},
        FILE_AND_FOLDER_DOWNLOAD_LATENCY: {name: 'WorkDocs_Companion_file_and_folder_download_latency'},
        EXPORT_AF_BUTTON_CLICKED: {name: 'WorkDocs_Companion_Export_AF_Clicked'},
        EXPORT_AF_LATENCY: {name: 'WorkDocs_Companion_export_af_latency'},
        EXPORT_USERS_BUTTON_CLICKED: {name: 'WorkDocs_Companion_Export_users_Clicked'},
        EXPORT_USERS_LATENCY: {name: 'WorkDocs_Companion_export_users_latency'},
        OPEN_WITH_ESTABLISHED_CHANNEL_FAILS: {name: 'WorkDocs_Companion_Open_With_Established_Channel_Fails'},
        OPEN_WITH_ESTABLISHED_CHANNEL_SUCCESS: {name: 'WorkDocs_Companion_Open_With_Established_Channel_Success'},
        CUSTOM_PROTOCOL_CALL_SUCCESS: {name: 'WorkDocs_Custom_Protocol_Call_Success'},
        CUSTOM_PROTOCOL_NOT_FOUND: {name: 'WorkDocs_Custom_Protocol_Not_Found'},
    };
    var CompanionExceptionPrefix = "WorkDocsClient.Components.";

    $rootScope.getDownloadDisabledReason = function() {
        var msg = null;
        var DOWNLOAD_FOLDER_MIN_COMPANION_VERSION = '1.0.57.0';

        if (BrowserService.isMobileOrTablet()) {
            msg = $translate.instant('MESSAGES.FRICTIONLESS_EDIT.TOOLTIPS.DEVICE_NOT_SUPPORTED');
        } else if (!isCompanionConnectionPossible()) {
            msg = $translate.instant('MESSAGES.FRICTIONLESS_EDIT.TOOLTIPS.BROWSER_NOT_SUPPORT');
        } else if (!$rootScope.companionDownloadButtonClicked && Utils.compareVersion(DOWNLOAD_FOLDER_MIN_COMPANION_VERSION, CompanionClientService.getClient().getCompanionVersion()) > 0) {
            msg = $translate.instant('MESSAGES.FRICTIONLESS_EDIT.TOOLTIPS.OLD_COMPANION', {
                companionDownloadUrl: getCompanionDownloadUrl()
            });
        }
        return msg;
    };

    var downloadFoldersAndFiles = function (files, folders) {
        if (!isCompanionConnectionPossible()) {
            showCompanionNotSupportedModal()
            return;
        }
        ClientMetricsService.startLatencyEvent(METRICS_EVENTS.FILE_AND_FOLDER_DOWNLOAD_LATENCY);
        MessageManager.addSuccessMessage($translate.instant('MESSAGES.FRICTIONLESS_EDIT.STARTING_FOLDER_AND_FILE_DOWNLOAD'));
        var request = {
            folderIdentifiers  : _.map(folders, 'Id').join(','),
            fileIdentifiers : _.map(files, 'Id').join(','),
            localFolderPath : ""
        };
        CompanionClientService.getClient().downloadFoldersAndFiles(request).then(function(response) {
            ClientMetricsService.stopAndRecordLatencyEvent(METRICS_EVENTS.FILE_AND_FOLDER_DOWNLOAD_LATENCY);
            MessageManager.addSuccessMessage($translate.instant('MESSAGES.FRICTIONLESS_EDIT.DOWNLOADING_FOLDERS_AND_FILES', {
                location: response
            }));
        }, function(error) {
            ClientMetricsService.stopAndRecordLatencyEvent(METRICS_EVENTS.FILE_AND_FOLDER_DOWNLOAD_LATENCY);
            MessageManager.addErrorMessage($translate.instant('MESSAGES.FRICTIONLESS_EDIT.ERROR_DOWNLOADING_FOLDERS_AND_FILES'));
        });
        ClientMetricsService.recordCounterEvent(METRICS_EVENTS.FILE_AND_FOLDER_DOWNLOAD_BUTTON_CLICKED, 1);
    };

    var downloadFolder = function(folder) {
        if (!isCompanionConnectionPossible()) {
            showCompanionNotSupportedModal()
            return;
        }
        ClientMetricsService.startLatencyEvent(METRICS_EVENTS.FOLDER_DOWNLOAD_LATENCY);
        MessageManager.addSuccessMessage($translate.instant('MESSAGES.FRICTIONLESS_EDIT.STARTING_FOLDER_DOWNLOAD'));
        var request = {
            workDocsFolderID: folder.Id,
            localFolderPath: folder.Name,
            recursive: true
        };
        CompanionClientService.getClient().downloadFolder(request).then(function(response) {                    
            ClientMetricsService.stopAndRecordLatencyEvent(METRICS_EVENTS.FOLDER_DOWNLOAD_LATENCY);
            MessageManager.addSuccessMessage($translate.instant('MESSAGES.FRICTIONLESS_EDIT.DOWNLOADING_FOLDER', {
                location: response
            }));
        }, function() {
            ClientMetricsService.stopAndRecordLatencyEvent(METRICS_EVENTS.FOLDER_DOWNLOAD_LATENCY);
            MessageManager.addErrorMessage($translate.instant('MESSAGES.FRICTIONLESS_EDIT.ERROR_DOWNLOADING_FOLDER'));
        });
        ClientMetricsService.recordCounterEvent(METRICS_EVENTS.FOLDER_DOWNLOAD_BUTTON_CLICKED, 1);
    };

    var purgeVersions = function(docId: string) {
        return $q(function (resolve, reject) {
            if (!isCompanionConnectionPossible()) {
                showCompanionNotSupportedModal()
                reject();
                return;
            }
            ClientMetricsService.startLatencyEvent(METRICS_EVENTS.PURGE_VERSIONS_LATENCY);
            CompanionClientService.getClient().purgeFileVersions({fileIdentifier: docId}).then(function(response) {
                ClientMetricsService.stopAndRecordLatencyEvent(METRICS_EVENTS.PURGE_VERSIONS_LATENCY);
                MessageManager.addSuccessMessage($translate.instant('MESSAGES.FRICTIONLESS_EDIT.PURGED_VERSIONS'));
                resolve(response.DocumentId);
            }, function() {
                reject();
                ClientMetricsService.stopAndRecordLatencyEvent(METRICS_EVENTS.PURGE_VERSIONS_LATENCY);
                MessageManager.addErrorMessage($translate.instant('MESSAGES.FRICTIONLESS_EDIT.ERROR_PURGING_VERSIONS'));
            });
        });
    };

    var exportActivityFeed = function(query: string, userID?: string, organizationID?: string, queryCategory?: 'USER_ACTIVITIES') {
        if (!isCompanionConnectionPossible()) {
            showCompanionNotSupportedModal()
            return;
        }
        ClientMetricsService.startLatencyEvent(METRICS_EVENTS.EXPORT_AF_LATENCY);
        MessageManager.addSuccessMessage($translate.instant('MESSAGES.FRICTIONLESS_EDIT.STARTING_AF_EXPORT'));
        
        CompanionClientService.getClient().downloadActivityFeeds({
            query: query,
            userID: userID,
            organizationID: organizationID,
            queryCategory: queryCategory
        }).then(function(response) {                    
            ClientMetricsService.stopAndRecordLatencyEvent(METRICS_EVENTS.EXPORT_AF_LATENCY);
            MessageManager.addSuccessMessage($translate.instant('MESSAGES.FRICTIONLESS_EDIT.EXPORTING_AF', {
                location: response
            }));
        }, function() {
            ClientMetricsService.stopAndRecordLatencyEvent(METRICS_EVENTS.EXPORT_AF_LATENCY);
            MessageManager.addErrorMessage($translate.instant('MESSAGES.FRICTIONLESS_EDIT.ERROR_EXPORTING_AF'));
        });
        ClientMetricsService.recordCounterEvent(METRICS_EVENTS.EXPORT_AF_BUTTON_CLICKED, 1);
    };

    var exportUsers = function(userTypes:string, userTypeText: string, orderBy: string, ascending: boolean, localFilePath: string) {
        if (!isCompanionConnectionPossible()) {
            showCompanionNotSupportedModal()
            return;
        }
        ClientMetricsService.startLatencyEvent(METRICS_EVENTS.EXPORT_USERS_LATENCY);
        // Set to null if optional parameter is empty
        orderBy = !!orderBy ? orderBy : null;
        ascending = !!ascending ? ascending : true;
        localFilePath = !!localFilePath ? localFilePath : null;
        
        var payload = {
            filterByUserTypesCSV : userTypes,
            orderBy : orderBy,
            ascending : ascending,
            localFilePath : localFilePath
        };
        CompanionClientService.getClient().downloadUsers(payload).then(function(response) {                    
            ClientMetricsService.stopAndRecordLatencyEvent(METRICS_EVENTS.EXPORT_USERS_LATENCY);
            MessageManager.addSuccessMessage($translate.instant('MESSAGES.FRICTIONLESS_EDIT.EXPORTING_USER_LIST', {
                userTypes: userTypeText,
                location: response
            }));
        }, function() {
            ClientMetricsService.stopAndRecordLatencyEvent(METRICS_EVENTS.EXPORT_USERS_LATENCY);
            MessageManager.addErrorMessage($translate.instant('MESSAGES.FRICTIONLESS_EDIT.ERROR_EXPORTING_USER_LIST'));
        });
        ClientMetricsService.recordCounterEvent(METRICS_EVENTS.EXPORT_USERS_BUTTON_CLICKED, 1);
    };

    var openInFrictionlessEdit = function(doc, documentVersionId: string, password?: string) {

        if (!isCompanionConnectionPossible()) {
            showCompanionNotSupportedModal()
            return;
        }
        ClientMetricsService.startLatencyEvent(METRICS_EVENTS.FILE_OPEN_LATENCY);
        MessageManager.addSuccessMessage($translate.instant('MESSAGES.FRICTIONLESS_EDIT.OPENING_DOCUMENT'));
        var request = {
            documentID : doc.Id,
            documentVersionID : documentVersionId,
            password: password? password: undefined,
        };
        CompanionClientService.getClient().editDocument(request).then(function() {
            ClientMetricsService.recordCounterEvent(METRICS_EVENTS.OPEN_WITH_ESTABLISHED_CHANNEL_SUCCESS, 1);
            ClientMetricsService.stopAndRecordLatencyEvent(METRICS_EVENTS.FILE_OPEN_LATENCY);
            MessageManager.addSuccessMessage($translate.instant('MESSAGES.FRICTIONLESS_EDIT.OPENED_DOCUMENT'));
        }, function(error) {
            if (error.message.indexOf(CompanionExceptionPrefix + 'UnsupportedDocumentTypeException') !== -1) {
                ClientMetricsService.recordCounterEvent({name: 'WorkDocs_Companion_Open_Unsupported_File_Fails'}, 1);
                MessageManager.addErrorMessage($translate.instant('MESSAGES.FRICTIONLESS_EDIT.ERROR_OPENING_DOCUMENT_UNSUPPORTED_FILE'));
            } else {
                ClientMetricsService.recordCounterEvent(METRICS_EVENTS.OPEN_WITH_ESTABLISHED_CHANNEL_FAILS, 1);
                MessageManager.addErrorMessage($translate.instant('MESSAGES.FRICTIONLESS_EDIT.ERROR_OPENING_DOCUMENT'));
            }
            ClientMetricsService.stopAndRecordLatencyEvent(METRICS_EVENTS.FILE_OPEN_LATENCY);
            $log.error(error.message);
        });
        ClientMetricsService.recordCounterEvent(METRICS_EVENTS.EDIT_BUTTON_CLICKED, 1);
    };

    var openInDrive = function(doc) {
        let userInfo = authenticatedUser.getUserInfo();
        editDocumentByCustomProtocol(doc.Id, userInfo.OrganizationId, doc.VersionMetadata.Name);
        ClientMetricsService.recordCounterEvent(METRICS_EVENTS.EDIT_BUTTON_CLICKED, 1);
    };

    function editDocumentByCustomProtocol(documentID: string, documentOwnerOrganizationId: string, documentName: string) {
        const url = `amazonworkdocs://editdocument?documentid=${documentID}&site=${documentOwnerOrganizationId}`;

        // Check if there is a Drive application which registers amazonworkdocs:// protocol
        customProtocolCheck(
            url,
            () => {
                // amazonworkdocs:// protocol does not exist
                console.debug("amazonworkdocs protocol NOT found.");
                ClientMetricsService.recordCounterEvent(METRICS_EVENTS.CUSTOM_PROTOCOL_NOT_FOUND, 1);
                showWorkDocsDesktopAppEditResultModal(documentName, false);
            },
            () => {
                // amazonworkdocs:// protocol exists
                console.debug("amazonworkdocs protocol found.");
                launchUri(url);
                ClientMetricsService.recordCounterEvent(METRICS_EVENTS.CUSTOM_PROTOCOL_CALL_SUCCESS, 1);

                if (localStorageService.get(AppConstants.LocalStorageKeys.DO_NOT_SHOW_EDIT_RESULT_MODAL) !== 'true') {
                    showWorkDocsDesktopAppEditResultModal(documentName, true);
                }
                
            }, 5000 //protocol check time out in ms
        );
    }

    function getCompanionDownloadUrl() {
        var region = RegionService.getRealRegion();
        var stage = EndpointConfig.stage(region);
        return getCompanionDownloadUrlCompanion(stage);
    };

    function isCompanionConnectionPossible() {
        // Currently, as long as the browser is supported, then the companion connection is possible
        return isCompanionSupportedBrowser();
    };

    function showCompanionNotSupportedModal() {
        $uibModal.open({
            templateUrl: './companionClient/companionNotSupportedModal/companionNotSupportedModal.html'
        });
    };

    function showWorkDocsDesktopAppEditResultModal(documentName: string, isDontShowAgainEnabled: boolean) {
        var modalInstance = $uibModal.open({
            templateUrl: './edit-modal/edit_result_modal_dialog.html',
            controller: 'gbEditResultModalCtrl',
            windowClass: "center-modal",
            resolve: {
                documentName: function() {
                    return documentName;
                },
                isDontShowAgainEnabled: function() {
                    return isDontShowAgainEnabled;
                }
            }
        });
        return modalInstance.result;
    };

    function launchUri(uri: string) {
        const launchScheme: string = launchUriScheme();
      
        if (launchScheme === 'msLaunchUri') {
          (navigator as any).msLaunchUri(
            uri,
            () => {},
            () => {}
          );
        } else if (launchScheme === 'chrome' || launchScheme === 'opera') {
          const iframe: HTMLIFrameElement = getHiddenIframe();
          try {
            iframe.contentWindow.location.href = uri;
          } catch (error) {
            // NS_ERROR_UNKNOWN_PROTOCOL or an unknown error will be thrown.
          } finally {
            // Cannot remove iframe for chrome. Removing it later through saga.
          }
        } else if (launchScheme === 'chromeMobile') {
          window.location.href = uri;
        } else if (launchScheme === 'firefox') {
          const iframe: HTMLIFrameElement = getHiddenIframe();
          try {
            iframe.contentWindow.location.href = uri;
          } catch (error) {
            // NS_ERROR_UNKNOWN_PROTOCOL or an unknown error will be thrown.
          }
        } else if (launchScheme === 'ie') {
          let popup: Window = window.open('', 'launcher', 'width=0,height=0');
          popup.location.href = uri;
          try {
            popup.location.href = 'about:blank';
            const timerCanceller = safeInterval(function () {
              popup.close();
              if (popup.closed && timerCanceller) {
                timerCanceller();
              }
            }, 500);
          } catch (error) {
            popup = window.open('about:blank', 'launcher');
            popup.close();
          }
        } else if (launchScheme === 'safariMobile') {
          window.location.href = uri;
        } else if (launchScheme === 'safari') {
          const iframe: HTMLIFrameElement = getHiddenIframe();
          iframe.contentWindow.location.href = uri;
        }
    };

    function safeInterval(handler: () => void, timeout: number) {
        let lastTimeout: ReturnType<typeof setTimeout> | null = null;
        const tick = () => {
            handler();
            if (lastTimeout) {
                lastTimeout = setTimeout(tick, timeout);
            }
        };
    
        const canceller = () => {
            if (lastTimeout) {
                clearTimeout(lastTimeout);
                lastTimeout = null;
            }
        };
    
        lastTimeout = setTimeout(tick, timeout);
        
        return canceller;
    }

    function launchUriScheme() {
        if ((navigator as any).msLaunchUri) {
          return 'msLaunchUri';
      
          /*
            Opera
            Mozilla/5.0 (Macintosh; Intel Mac OS X 10_11_6) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/55.0.2883.87 Safari/537.36 OPR/42.0.2393.94
          */
        } else if ((window as any).chrome && navigator.userAgent.match(/Opera|OPR\//)) {
          return 'opera';
        } else if ((window as any).chrome && navigator.userAgent.match(/Mobile/)) {
          return 'chromeMobile';
        } else if ((window as any).chrome) {
          return 'chrome';
        } else if (typeof InstallTrigger !== 'undefined') {
          return 'firefox';
      
          /*
            IE 11 Windows 7
            Mozilla/5.0 (Windows NT 6.1; WOW64; Trident/7.0; SLCC2; .NET CLR 2.0.50727; .NET CLR 3.5.30729; .NET CLR 3.0.30729; Media Center PC 6.0; .NET4.0C; .NET4.0E; rv:11.0) like Gecko
          */
        } else if (
          navigator.userAgent.match(/Trident/) ||
          navigator.appName === 'Microsoft Internet Explorer'
        ) {
          return 'ie';
      
          /*
            Safari iOS in web view
            Mozilla/5.0 (iPad; CPU OS 9_3_3 like Mac OS X) AppleWebKit/601.1.46 (KHTML, like Gecko) Mobile/13G34
            Safari iOS in browser
            Mozilla/5.0 (iPhone; CPU iPhone OS 10_0_2 like Mac OS X) AppleWebKit/602.1.50 (KHTML, like Gecko) Version/10.0 Mobile/14A456 Safari/602.1
          */
        } else if (navigator.userAgent.match(/AppleWebKit/) && navigator.userAgent.match(/Mobile/)) {
          return 'safariMobile';
      
          /*
            Safari Mac OS X in browser
            Mozilla/5.0 (Macintosh; Intel Mac OS X 10_11_6) AppleWebKit/602.3.12 (KHTML, like Gecko) Version/10.0.2 Safari/602.3.12
            Safari Mac OS X in web view
            Mozilla/5.0 (Macintosh; Intel Mac OS X 10_11_6) AppleWebKit/601.7.8 (KHTML, like Gecko)
          */
        } else if (navigator.userAgent.match(/AppleWebKit/)) {
          return 'safari';
        }
      
        return null;
    };

    function getHiddenIframe() {
        return document.getElementById('ClientDetectionIframe') as HTMLIFrameElement;
    };

    return {
        isCompanionConnectionPossible: isCompanionConnectionPossible,
        exportActivityFeed: exportActivityFeed,
        exportUsers: exportUsers,
        downloadFoldersAndFiles: downloadFoldersAndFiles,
        downloadFolder: downloadFolder,
        showCompanionNotSupportedModal:showCompanionNotSupportedModal,
        openInFrictionlessEdit: openInFrictionlessEdit,
        purgeVersions: purgeVersions,
        getCompanionDownloadUrl: getCompanionDownloadUrl,
        openInDrive: openInDrive
    };
}
